module.exports = __webpack_public_path__ + "img/ringPerimeter.6082176.jpg";